<template lang="html">
  <div class="progress" style="justify-content: space-between;">
    <div
      class="progress-bar"
      role="progressbar"
      :style="'width:' + percent + '%;'"
      aria-valuenow=""
      aria-valuemin="0"
      aria-valuemax="100"
    >
      {{ percent }}%
    </div>
  </div>
</template>

<script>
export default {
  props: ['percent'],
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/parts/components/progress.vue